import { usePriceSection } from "./usePriceSection";
export const usePriceComponents = () => { var _a; return (_a = usePriceSection()) === null || _a === void 0 ? void 0 : _a.components; };
